/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum IconSize {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large'
}
